import React from "react";
import { FileReference } from "../../amorg-common";
import { Modal } from "../Modal";
import { ReferenceFilesPanel } from "./ReferenceFilesPanel";
import { getReferenceFiles } from "../../api/filesClientApi";
import { Button } from "../button/Button";
import { Flex } from "./FlexHelpers";


export function ReferenceFilesModal (props: {
    show: boolean,
    fileReference: FileReference,
    title?: string,
    onGetFilesCount?: (count: number) => void,
    onClose: () => void
})
{
    return (
        <Modal 
            showModal={props.show} 
            title={props.title ?? "Vedhæftede filer"}
            onCancel={props.onClose}
            content={
                <ReferenceFilesPanel
                    modalEditing={false}
                    hide={false}
                    referenceType={props.fileReference.type}
                    objectId={props.fileReference.id}
                    onGetFilesCount={props.onGetFilesCount}
                
                />
            } 
        />
    );
}

export function ReferenceFilesModalButton(props: {
    fileReference:FileReference,
    title?: string
}) {
    const [showModal, setShowModal] = React.useState<boolean>(false);
    const [fileCount, setFileCount] = React.useState<number | undefined>(undefined);

    React.useEffect(() => {
        const getData = async () => {
            const count = (await getReferenceFiles(props.fileReference)).length;
            setFileCount(count);
        };
        getData();
    }, [props.fileReference]);

    function handleGetFilesCount(count: number) {
        setFileCount(count);
    }

    async function handleCloseModal() {
        setShowModal(false);
    }


    return (
        <>
            <Flex gap={4} alignItems="center">
                <Button 
                    variant="text" 
                    icon="interface_actions_attach"
                    size="32px"
                    text={fileCount === undefined 
                        ? `Vedhæftede filer` 
                        : `Vedhæftede filer (${fileCount})`
                    }
                    onClick={() => setShowModal(true)} />
            </Flex>

            <ReferenceFilesModal
                show={showModal}
                fileReference={props.fileReference}
                title={props.title}
                onGetFilesCount={handleGetFilesCount}
                onClose={handleCloseModal}
            />
        </>
    );
}
